import React from "react";
export default function Heading(props) {
    const { tag, text, underline, underline_offset, underline_block, text_align, color, content_type } = props;
    let text_content = text;
    const classList = [
        'ltg-heading',
        underline == 'yes' ? ' ltg-heading--underlined' : null,
        underline_block == 'yes' ? ' ltg-heading--underlined-block' : null,
        text_align != 'left' ? `text-${text_align}` : null,
        (!!color && color !== 'default') ? `text-${color}` : null
    ];
    return React.createElement(tag || 'h2', {
        className: classList.filter(i => !!i).join(' '),
        style: (!!underline && underline_offset) ? { '--ltg-heading-underline-offset': `${underline_offset}px` } : null
    }, underline == 'yes' ? React.createElement("span", null, text_content) : text_content);
}
